import { createRouter, createWebHashHistory } from "vue-router";
import Main from "@/views/Main.vue";
import Login from "@/views/Login.vue";
import Register from "@/views/register.vue";
import Forgot from "@/views/forgot.vue";

import { generateRoutes } from "@/utils/generateRoutes";

/**
 * 生成初始路由
 */
const menuList = JSON.parse(window.sessionStorage.getItem("menuList"));
const routesApi = (menuList && generateRoutes(menuList)) || [];

const initialRoutes = [
  {
    path: "/",
    component: Main,
    redirect: "/dashboard",
    children: routesApi,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/forgot",
    name: "forgot",
    component: Forgot,
  },
];

/**
 * 创建 Vue Router 实例
 */
const router = createRouter({
  history: createWebHashHistory(), // ✅ 改成 Hash 模式
  routes: initialRoutes,
});

/**
 * 刷新路由函数（用于动态菜单更新）
 */
export function refreshRoutes() {
  const menuList = JSON.parse(window.sessionStorage.getItem("menuList")) || [];
  const routesApi = generateRoutes(menuList);

  // 移除除 login 外的所有动态路由
  router.getRoutes().forEach((r) => {
    if (r.name && r.name !== "login" && r.name !== "register") {
      router.removeRoute(r.name);
    }
  });

  // 添加主页面 '/'，并添加动态子路由
  const mainRoute = {
    path: "/",
    component: Main,
    redirect: routesApi.length ? routesApi[0].path : "/dashboard",
    children: routesApi,
  };

  router.addRoute(mainRoute);

  // 确保 login 路由存在
  if (!router.hasRoute("login")) {
    router.addRoute({
      path: "/login",
      name: "login",
      component: Login,
    });
  }

  if (!router.hasRoute("register")) {
    router.addRoute({
      path: "/register",
      name: "register",
      component: Register,
    });
  }
  if (!router.hasRoute("forgot")) {
    router.addRoute({
      path: "/forgot",
      name: "forgot",
      component: Forgot,
    });
  }
}

export default router;
